type EventParams = {
    [key: string]: string | number | undefined;
  };
  
  export const trackEvent = (eventName: string, params: { [key: string]: any } = {}): void => {
    if (window.gtag) {
      window.gtag('event', eventName, params);
    } else {
      console.warn('Google Analytics is not initialized');
    }
  };